import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '../Typography/CustomTypography';

const useStyles = makeStyles((theme) => ({
    title: {
        [theme.breakpoints.up('lg')]: {
            marginLeft: '-260px',
        },
    },
}));

const ViewHeader = (props) => {
    const {
        eventName, title, isIntl, eventInfo,
    } = props;
    const intl = useIntl();
    const classes = useStyles();
    return (
        <Box display="flex" flexDirection="column" style={{ width: '100%' }}>
            <Typography
                variant="h5"
                bold
                align="right"
                color="event"
                customColor={eventInfo?.settings_colors_viewer?.event_name_text_color}
            >
                {eventName}
            </Typography>
            <Typography
                bold
                variant="h3"
                color="navy"
                align="center"
                style={{ padding: '8px 0' }}
                customColor={eventInfo?.settings_colors_viewer?.screen_name_text_color}
            >
                {isIntl ? intl.formatMessage({ id: title }) : "<"+ title +">"}
            </Typography>
        </Box>
    );
};

ViewHeader.defaultProps = {
    eventName: '',
    title: '',
    isIntl: true,
    eventInfo: {},
};

ViewHeader.propTypes = {
    eventName: PropTypes.string,
    title: PropTypes.string,
    isIntl: PropTypes.bool,
    eventInfo: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default ViewHeader;
